export default Object.freeze({
  GeneralSupport: 1,
  EngineAI: 2,
  EmailSupport: 3,
  UserDefault: 4,
  AppBuilder: 5,
  EntityBuilder: 6,
  ProcessBuilder: 7,
  AgentBuilder: 8,
  ListBuilder: 9,
});
